export default __webpack_public_path__ + "static/media/IncredibleAnimalsHibernators_09.7182d366.png";